import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";
import { useEffect, useState } from "react";
import QRCode from "qrcode";
import Expired from "../assets/img/expired.png";
import { useNavigate } from "react-router-dom";

interface ExpiredModalProps extends ModalProps {
  onHide: () => void;
  show: boolean;
  message?: string;
  extendTicketUrl: string;
}

const ExpiredModal = ({
  onHide,
  show,
  message,
  extendTicketUrl,
  ...props
}: ExpiredModalProps) => {
  const navigate = useNavigate();
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  useEffect(() => {
    if (!extendTicketUrl) {
      setQrCodeUrl("");
      return;
    }

    QRCode.toDataURL(extendTicketUrl, {
      errorCorrectionLevel: "H",
      margin: 1,
      width: 260,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    })
      .then(setQrCodeUrl)
      .catch(() => setQrCodeUrl(""));
  }, [extendTicketUrl]);

  const handleCancel = () => {
    onHide();
    navigate("/");
  };

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      show={show}
      onHide={onHide}
      backdrop="static"
      className="expiredModal"
      centered
    >
      <Modal.Body>
        <div className="otpModalBody">
          <img src={Expired} alt="Expired" className="expiredImg" />
          <div className="header">Your ticket is already expired</div>
          <div className="description">
            Please scan this QR code to extend your time and pay.
          </div>
          {message && <div className="description">{message}</div>}
          <div className="text-center">
            <div className="qrCodeCard">
              {qrCodeUrl ? (
                <>
                  <img
                    src={qrCodeUrl}
                    alt="Extend ticket QR Code"
                    className="qrCodeImage"
                  />
                  <div className="qrLogo">MOSIDA</div>
                </>
              ) : (
                <div className="description">Unable to generate extend QR.</div>
              )}
            </div>
          </div>
          <div className="mt-4">
            <button
              type="button"
              className="btnPrimary w-100"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExpiredModal;
